import { useFileInput } from './Root'
import * as Icons from "react-icons/fi";

export function Trigger() {
  const { id } = useFileInput()
  return (
    <label
      htmlFor={id}
      className="tw-group hover:tw-bg-violet-100 tw-flex tw-flex-1 tw-cursor-pointer tw-flex-col tw-items-center tw-gap-3 tw-rounded-lg tw-border tw-border-zinc-300 tw-px-6 tw-py-4 tw-text-center tw-text-zinc-500 tw-shadow-sm hover:tw-border-violet-200 hover:tw-text-violet-500"
    >
      <div className="tw-rounded-full tw-border-6 tw-border-zinc-50 tw-bg-zinc-100 tw-p-2 group-hover:tw-border-violet-50 group-hover:tw-bg-violet-100">
        <Icons.FiUploadCloud className="tw-h-5 tw-w-5 tw-text-zinc-600 group-hover:tw-text-violet-600" />
      </div>
      <div className="tw-flex tw-flex-col tw-items-center tw-gap-1">
        <span>
          <span className="tw-font-semibold tw-text-violet-700">Click to upload</span>{' '}
        </span>
        <span className="tw-text-sm">timesheet (.xls,.xlsx)</span>
      </div>
    </label>
  )
}
